import React, { useEffect, useMemo, useState, useRef } from "react";
import { useIntl } from "react-intl";
import { clone, isEmpty, isNil } from "ramda";

import { loadAverageTemporalData, spatialSelectHandler } from "./utils";
import LineChart from "../LineChart";
import WaterfallChart from "../WaterfallChart";
import palette from "../../../../../config/colorPalette";
import MapAnalysis from "../MapAnalysis";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  IconButton,
  MenuItem,
  TextField,
} from "@mui/material";
import { useSelector } from "react-redux";
import { deleteDoBDataId, getMovingAverageData, getMovingAverageTemporal, postDoBData } from "../../../../api";
import MapDob from "../MapDob";
import DoBLineChart from "../LineChart/dobLineChart";
import { loadDoBfile } from "../../utils";
import { ThemeProvider } from "styled-components";
import { getMuiTheme } from "../../../../utils/utils";
import { LoadingButton } from "@mui/lab";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format, startOfDay } from "date-fns";
import Plot from "react-plotly.js";

const NormalDataVisualization = ({
  title,
  measureName,
  currentAsset,
  assetName,
  asignedChannels,
  initialPointIndex,
  endPointIndex,
  data: spatialDataList,
  temporalData,
  minsW,
  maxsW,
  assetsPoints,
  datetime,
  dateTimeList,
  scales,
  percentiles,
  differences,
  equipment,
  channel,
  substructure,
  selectedEquipment,
  colorMaps,
  isAlert,
  startDate,
  alertMeasure,
  afterAlert,
  setAfterAlert,
  loadingTemporal,
  configData,
  assetModule,
  intensityData,
  assetSensors,
  assetInfo,
  nonMeasurands,
  alertsList,
  allAlerts,
  allData,
  measurandsFiltered,
  setData,
  userData,
  dobDates,
  setDobDates,
}) => {
  const intl = useIntl();
  const theme = useMemo(() => getMuiTheme(), []);
  const [temporalDataList, setTemporalDataList] = useState([]);
  const [environmentalDataList, setEnvironmentalDataList] = useState([]);
  const [minsWaterfall, setMinsWaterfall] = useState([]);
  const [maxsWaterfall, setMaxsWaterfall] = useState([]);
  const [loading, setLoading] = useState(true);
  const [startZoom, setStartZoom] = useState();
  const [endZoom, setEndZoom] = useState();
  const [startIndex, setStartIndex] = useState(null);
  const [endIndex, setEndIndex] = useState(null);
  const [waterfallColors, setWaterfallColors] = useState(null);
  const [period, setPeriod] = useState(30);
  const [maximum, setMaximum] = useState(1000);
  const periodRef = useRef(null);
  const maximumRef = useRef(null);
  const [alertLines, setAlertLines] = useState({ start: null, end: null });
  const equipmentTypes = useSelector((state) => state.equipmentTypeData.data);
  const [movingBoolean, setMovingBoolean] = useState(false); //Promedio móvil
  const [movingAverage, setMovingAverage] = useState(selectedEquipment.channels[channel - 1].info.samplingInterval); //Promedio móvil
  const [chartMovingAverageData, setChartMovingAverageData] = useState(null);
  const [movingBooleanTemporal, setMovingBooleanTemporal] = useState(false); //Promedio móvil
  const [movingAverageTemporal, setMovingAverageTemporal] = useState(selectedEquipment.measurementInfo.interval); //Promedio móvil
  const [averageMeasurement, setAverageMeasurement] = useState("minutes");
  const [chartMovingAverageTemporal, setChartMovingAverageTemporal] = useState(null);
  const [temporalValue, setTemporalValue] = React.useState(
    movingAverageTemporal / (averageMeasurement === "days" ? 86400 : averageMeasurement === "hours" ? 3600 : 60),
  );
  const [loadingAverage, setLoadingAverage] = useState(false);
  const [loadingAverageTemporal, setLoadingAverageTemporal] = useState(false);
  const [manualPk, setManualPk] = useState([0]);
  const [selectTemporal, setSelectTemporal] = useState(false);
  const colors = [
    "#5470C6", // Azul fuerte
    "#91CC75", // Verde suave
    "#EE6666", // Rojo intenso
    "#9A60B4", // Púrpura
    "#FAC858", // Amarillo dorado
    "#EA7CCC", // Rosa claro
    "#FC8452", // Naranja
    "#73C0DE", // Azul cielo
    "#3BA272", // Verde bosque
    "#FF5733", // Naranja rojizo
    "#33FF57", // Verde brillante
    "#5733FF", // Azul eléctrico
    "#FFD700", // Oro
    "#40E0D0", // Turquesa
    "#8A2BE2", // Violeta
    "#FF69B4", // Rosa fuerte
    "#7FFF00", // Chartreuse
    "#DC143C", // Carmesí
    "#00CED1", // Azul oscuro
    "#4682B4", // Acero azul
    "#32CD32", // Verde lima
    "#FF4500", // Naranja rojizo
    "#9400D3", // Violeta oscuro
    "#20B2AA", // Verde aguamarina
    "#FFDAB9", // Melocotón
    "#B22222", // Rojo ladrillo
    "#00FA9A", // Verde primavera
    "#191970", // Azul medianoche
    "#ADFF2F", // Verde amarillo
  ];
  const [dobModal, setDobModal] = useState(false);
  const [dobHistorical, setDobHistorical] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [dobFile, setDobFile] = useState(null);
  useEffect(() => {
    if (!isAlert) {
      setAfterAlert(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAlert]);
  //const points = useMemo(
  //  () => assetsPoints?.data?.[`${assetName}${asignedChannels[channel - 1] + 1}`] ?? [],
  //  [assetsPoints, assetName, asignedChannels, channel],
  //);

  //useEffect(() => {
  //  if (
  //    !isNil(spatialDataList) &&
  //    !isNil(spatialDataList[0].values) &&
  //    initialPointIndex !== 0 &&
  //    endPointIndex !== spatialDataList[0].values.length - 1
  //  ) {
  //    setStartIndex(initialPointIndex);
  //    setEndIndex(endPointIndex);
  //  }
  //  // eslint-disable-next-line react-hooks/exhaustive-deps
  //}, [spatialDataList]);

  useEffect(() => {
    const numColors = 15;
    const convertedColormaps = convertColormaps(colorMaps, numColors);
    setWaterfallColors(convertedColormaps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colorMaps]);

  function rgbToHex(r, g, b) {
    return "#" + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1).toUpperCase();
  }

  function reduceColors(colors, numColors) {
    const step = Math.floor(colors.length / numColors);
    return colors.filter((_, index) => index % step === 0).slice(0, numColors);
  }

  function convertColormaps(colormaps, numColors) {
    const result = {};
    for (const [key, value] of Object.entries(colormaps)) {
      const hexColors = value.red.map((r, i) => rgbToHex(r * 255, value.green[i] * 255, value.blue[i] * 255));
      result[key] = reduceColors(hexColors, numColors);
    }
    return result;
  }
  function argminClosest(pkArray, value) {
    let minIndex = 0;
    let minDiff = Math.abs(pkArray[0] - value);

    for (let i = 1; i < pkArray.length; i++) {
      const diff = Math.abs(pkArray[i] - value);
      if (diff < minDiff) {
        minDiff = diff;
        minIndex = i;
      }
    }

    return minIndex;
  }
  const chartSpatialData = useMemo(
    () => {
      const nonM = nonMeasurands.find((m) => m.name === measureName);
      const markAreaDataTotal = [];
      const markAreaDataPartial = [];
      if (!isEmpty(nonM)) {
        const newAlertsList = alertsList.measurements.filter(
          (alert) => alert.package === measureName && alert.active && !alert.isArchived,
        ); //active = true y sin archivar
        if (!isEmpty(newAlertsList)) {
          const actualPoints =
            assetsPoints.data[`${assetName}_${substructure.polyline}_${selectedEquipment.equipmentType}`].points;
          const seaLocation = actualPoints.findIndex((point) => point.surface_type === "sea");
          const deducter = seaLocation >= 0 ? actualPoints[seaLocation].pk : 0;
          const colors = ["rgba(255, 174, 0, 0.48)", "rgba(255, 0, 13, 0.4)"];
          for (let indexAlert = 0; indexAlert < newAlertsList.length; indexAlert++) {
            if (
              new Date(newAlertsList[indexAlert].dateStart) <= new Date(datetime) &&
              new Date(newAlertsList[indexAlert].dateEnd) >= new Date(datetime)
            ) {
              if (newAlertsList[indexAlert].value === 2) {
                markAreaDataTotal.push([
                  {
                    xAxis: newAlertsList[indexAlert].startPoint - deducter,
                    itemStyle: {
                      color: colors[newAlertsList[indexAlert].value - 1],
                    },
                  },
                  {
                    xAxis: newAlertsList[indexAlert].endPoint - deducter,
                  },
                ]);
              } else {
                markAreaDataPartial.push([
                  {
                    xAxis: newAlertsList[indexAlert].startPoint - deducter,
                    itemStyle: {
                      color: colors[newAlertsList[indexAlert].value - 1],
                    },
                  },
                  {
                    xAxis: newAlertsList[indexAlert].endPoint - deducter,
                  },
                ]);
              }
            }
          }
        }
      }
      if (isEmpty(spatialDataList[0])) return null;
      const areaSeries =
        measureName.includes("dob") || measureName === "DoB"
          ? [
              {
                name: `sDoB Total`,
                type: "line",
                icon: "rect",
                lineStyle: { opacity: 0 },
                itemStyle: { color: "rgba(255, 0, 13, 0.4)" },
                data: [],
                symbol: "rect",
                symbolSize: 14,
                showSymbol: true,
                markArea: {
                  data: markAreaDataTotal,
                },
              },
              {
                name: `sDoB ${intl.formatMessage({ id: "partial" })}`,
                type: "line",
                icon: "rect",
                lineStyle: { opacity: 0 },
                itemStyle: { color: "rgba(255, 174, 0, 0.48)" },
                data: [],
                symbol: "rect",
                symbolSize: 14,
                showSymbol: true,
                markArea: {
                  data: markAreaDataPartial,
                },
              },
            ]
          : null;
      if (isNil(spatialDataList?.[0]?.values)) return null;
      return {
        xAxis: {
          data: spatialDataList?.[0]?.pk,
        },
        series: [
          ...spatialDataList
            .filter((d) => d && Object.keys(d).length > 0)
            .map((d, dataIndex) => ({
              name:
                measureName.includes("dob") || measureName === "DoB"
                  ? `DoB ROV ${dobDates[dataIndex]}`
                  : spatialDataList.length === 1
                    ? `${d?.datetime?.replace("T", " ")}`
                    : `${selectedEquipment.channels[d.channel - 1].name}-${d?.datetime?.replace("T", " ")}`,
              data: d.values.map((value, valueIndex) => [
                parseFloat(spatialDataList?.[0]?.pk[valueIndex].toFixed(1)),
                value,
              ]),
              type: "line",
            })),
        ],
        bathymetry: [
          ...spatialDataList
            .filter((d) => d && Object.keys(d).length > 0)
            .map((d, dataIndex) => ({
              name: `${intl.formatMessage({ id: "bathymetry" })}-${dobDates[dataIndex]}`,
              type: "line",
              data: d?.seabed?.map((value, valueIndex) => [
                parseFloat(spatialDataList?.[0]?.pk[valueIndex].toFixed(1)),
                value,
              ]),
            })),
        ],
        zones: measureName.includes("dob") || measureName === "DoB" ? areaSeries : [],
        title: `${intl.formatMessage({ id: title })} (${intl.formatMessage({ id: "spatial" })})`,
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [spatialDataList, title, intl],
  );
  const chartTemporalData = useMemo(() => {
    if (!isEmpty(temporalDataList) && isNil(temporalDataList.image)) {
      const formattedSeries = temporalDataList?.map((d) => ({
        name: d.pk,
        data: d.datetimes.map((datetime, index) => [new Date(datetime), d.values[index]]),
        title: d.measurand,
        type: "line",
        symbolSize: 1,
        sensor_ID: d.sensor_ID,
      }));
      return {
        xAxis: {
          data: temporalDataList?.[0]?.datetimes?.map((str) => str),
        },
        series: formattedSeries,
        measurand: measureName,
        title: `${intl.formatMessage({ id: title })} (${intl.formatMessage({ id: "temporal" })})`,
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [temporalDataList, title, intl]);

  const chartEnvironmentalData = useMemo(() => {
    if (!isEmpty(environmentalDataList)) {
      const formattedSeries = environmentalDataList?.map((d) => ({
        name: d.pk,
        data: d.datetimes.map((datetime, index) => [new Date(datetime), d.values[index]]),
        title: d.measurand + " " + d.sensor_ID,
        measurand: d.measurand,
        type: "line",
        symbolSize: 1,
      }));
      const measurands = [];
      for (let indexSensor = 0; indexSensor < environmentalDataList.length; indexSensor++) {
        if (!measurands.includes(environmentalDataList[indexSensor].measurand)) {
          measurands.push(environmentalDataList[indexSensor].measurand);
        }
      }

      return {
        xAxis: {
          data: environmentalDataList?.[0]?.datetimes?.map((str) => str),
        },
        series: formattedSeries,
        measurands: measurands,
        title: `${measurands.toString()} (${intl.formatMessage({ id: "temporal" })})`,
      };
    }
  }, [environmentalDataList, intl]);
  const chartTemporalWaterfallData = useMemo(() => {
    //const options = {
    //  year: "numeric",
    //  month: "short",
    //  day: "numeric",
    //  hour: "2-digit",
    //  minute: "2-digit",
    //  second: "2-digit",
    //};
    const moduleData = configData.modules.find((module) => module.name === assetModule);
    const packageData = moduleData.packages.find((packg) => packg.name === measureName);
    const seriesData = temporalDataList?.flatMap((d, i) =>
      d.datetimes.map((datetime, j) => [j, i, d.values[j] || "-"]),
    );
    const zData = convertirSeriesAHeatmap(seriesData);
    return {
      xAxis: {
        type: "date",
        text: intl.formatMessage({ id: "date" }),
        data: temporalDataList?.[0]?.datetimes,
      },
      yAxis: {
        type: "value",
        text: "PK (m)",
        data: temporalDataList?.map((d) => d.pk.toFixed(2)),
      },
      graphic: packageData?.graphic,
      series: [
        {
          data: zData,
        },
      ],
      title: `${intl.formatMessage({ id: title })} (${packageData?.unit}) (${intl.formatMessage({
        id: "waterfall",
      })})`,
      base64: temporalDataList?.[0]?.base64,
      limits: temporalDataList?.[0]?.limits,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [temporalDataList, title, intl]);

  function convertirSeriesAHeatmap(seriesData) {
    const maxX = Math.max(...seriesData.map((d) => d[0]));
    const maxY = Math.max(...seriesData.map((d) => d[1]));

    const z = Array.from({ length: maxY + 1 }, () => Array(maxX + 1).fill(null));

    seriesData.forEach(([x, y, value]) => {
      z[y][x] = value;
    });

    return z;
  }

  useEffect(() => {
    const fetchData = async () => {
      if (!movingBoolean) {
        setChartMovingAverageData(null);
        return;
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [movingBoolean]);

  useEffect(() => {
    const fetchData = async () => {
      if (!movingBooleanTemporal) {
        setChartMovingAverageTemporal(null);
        return;
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [movingBooleanTemporal]);

  useEffect(() => {
    if (!isNil(startIndex) && !isNil(endIndex)) {
      const newManualPk = [];
      for (let indexManual = 0; indexManual < manualPk.length; indexManual++) {
        newManualPk.push(argminClosest(spatialDataList?.[0]?.pk, manualPk[indexManual]));
      }
      spatialSelectHandler({
        data: chartSpatialData,
        start: startIndex,
        end: endIndex,
        setStartIndex,
        setEndIndex,
        measureName,
        setTemporalDataList,
        setEnvironmentalDataList,
        minsWaterfall,
        setMinsWaterfall,
        maxsWaterfall,
        setMaxsWaterfall,
        currentAsset,
        spatialDataList,
        setLoading,
        datetime,
        equipment,
        selectedEquipment,
        channel,
        substructure,
        period,
        maximum,
        alertMeasure,
        startDate,
        afterAlert,
        setAfterAlert,
        equipmentTypes,
        manualPk: newManualPk,
        assetSensors,
        intensityData,
      });
    } else {
      setLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [period, maximum, intensityData]);
  useEffect(() => {
    setTemporalDataList(temporalData ?? []);
  }, [temporalData]);
  useEffect(() => {
    setMinsWaterfall(minsW ?? []);
  }, [minsW]);
  useEffect(() => {
    setMaxsWaterfall(maxsW ?? []);
  }, [maxsW]);
  useEffect(() => {
    setLoading(loadingTemporal);
  }, [loadingTemporal]);

  useEffect(
    () =>
      setStartZoom(
        !isNil(initialPointIndex) && !isNil(chartSpatialData?.xAxis?.data)
          ? (initialPointIndex * 100) / chartSpatialData.xAxis.data.length
          : 0,
      ),
    [initialPointIndex, chartSpatialData],
  );
  useEffect(
    () =>
      setEndZoom(
        !isNil(endPointIndex) && !isNil(chartSpatialData?.xAxis?.data)
          ? (endPointIndex * 100) / chartSpatialData.xAxis.data.length
          : 100,
      ),
    [endPointIndex, chartSpatialData],
  );

  useEffect(() => {
    if (movingBooleanTemporal && !isEmpty(temporalDataList)) {
      loadAverageTemporalData({
        assetName,
        equipment,
        channel,
        datetime,
        movingAverageTemporal,
        manualPk,
        maximum,
        period,
        assetModule,
        substructure,
        measureName,
        temporalDataList,
        colors,
        title,
        setLoadingAverageTemporal,
        setChartMovingAverageTemporal,
        intl,
      });
    }
  }, [temporalDataList]);

  if (isNil(spatialDataList)) {
    return <div style={{ height: "92vh", display: "flex", justifyContent: "center", alignItems: "center" }}></div>;
  }

  return !isEmpty(spatialDataList) && !isNil(spatialDataList[0].values) ? (
    <div
      style={{
        width: "99%",
        margin: "1rem",
        padding: "0.5rem",
        display: "grid",
        gap: "1rem",
        border: `1px solid ${palette.primary}`,
        pointerEvents: loading ? "none" : "auto",
        position: "relative",
      }}
    >
      <h3 style={{ color: palette.primary }}>{intl.formatMessage({ id: title }).toUpperCase()}</h3>
      {loading && (
        <div
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "rgb(176 176 176 / 60%)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            position: "absolute",
          }}
        >
          {`${intl.formatMessage({ id: "loading" })}...`}
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", width: "85vw" }}>
        <div style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}>
          {!measureName.includes("dob") && measureName !== "DoB" ? (
            <>
              {manualPk.map((mPk, pkIndex) => (
                <React.Fragment key={`pk_picker_${title}_${pkIndex}_div`}>
                  <TextField
                    id={`pk_picker_${title}_${pkIndex}`}
                    style={{ marginRight: "0.5rem", width: "7rem" }}
                    inputProps={{ min: 0, max: spatialDataList[0].pk[spatialDataList[0].pk.length - 1] }}
                    value={mPk}
                    variant="outlined"
                    label={`PK ${pkIndex + 1}`}
                    type="number"
                    onChange={(event) => {
                      let newPk = clone(manualPk);
                      const lastPk = spatialDataList[0].pk[spatialDataList[0].pk.length - 1].toFixed(2);
                      if (parseInt(event.target.value) > lastPk) {
                        newPk[pkIndex] = lastPk;
                      } else {
                        newPk[pkIndex] = parseInt(event.target.value);
                      }
                      setManualPk(newPk);
                    }}
                  />
                  {pkIndex > 0 && (
                    <DeleteForeverIcon
                      onClick={() => {
                        let newPk = clone(manualPk);

                        if (pkIndex > -1) {
                          newPk.splice(pkIndex, 1);
                        }
                        setManualPk(newPk);
                      }}
                      sx={{ color: palette.primary, cursor: "pointer" }}
                    />
                  )}
                </React.Fragment>
              ))}
              <IconButton
                style={{ backgroundColor: palette.dividerLight, marginRight: "0.5%" }}
                key={`add_pk`}
                onClick={() => {
                  let newPk = clone(manualPk);
                  newPk.push(0);
                  setManualPk(newPk);
                }}
              >
                <AddIcon sx={{ color: palette.primary }} />
              </IconButton>
              <Button
                id={`pk_picker_${title}_button`}
                variant="contained"
                style={{
                  height: "3.6rem",
                  backgroundColor: palette.primary,
                  color: "white",
                }}
                size="small"
                onClick={async () => {
                  const pkList = spatialDataList[0].pk;
                  let indexPk = pkList.indexOf(manualPk);

                  if (indexPk < 0) {
                    let closestValue = pkList.reduce((prev, curr) =>
                      Math.abs(curr - manualPk) < Math.abs(prev - manualPk) ? curr : prev,
                    );

                    indexPk = pkList.indexOf(closestValue);
                  }
                  const newManualPk = [];
                  for (let indexManual = 0; indexManual < manualPk.length; indexManual++) {
                    newManualPk.push(argminClosest(pkList, manualPk[indexManual]));
                  }
                  setStartIndex(indexPk);
                  setEndIndex(indexPk);
                  spatialSelectHandler({
                    data: chartSpatialData,
                    start: indexPk,
                    end: indexPk,
                    setStartIndex,
                    setEndIndex,
                    measureName,
                    setTemporalDataList,
                    setEnvironmentalDataList,
                    minsWaterfall,
                    setMinsWaterfall,
                    maxsWaterfall,
                    setMaxsWaterfall,
                    currentAsset,
                    spatialDataList,
                    setLoading,
                    datetime,
                    equipment,
                    selectedEquipment,
                    channel,
                    substructure,
                    period,
                    maximum,
                    alertMeasure,
                    startDate,
                    afterAlert,
                    setAfterAlert,
                    equipmentTypes,
                    manualPk: newManualPk,
                    intensityData,
                    assetSensors,
                  });
                }}
              >
                {intl.formatMessage({ id: "load.temporal.data" })}
              </Button>
              <Divider orientation="vertical" style={{ borderColor: palette.dividerLight, marginLeft: "1rem" }} />
              <FormControlLabel
                control={
                  <Checkbox
                    id={"checkbox" + title}
                    sx={{
                      color: palette.primary,
                      "&.Mui-checked": {
                        color: palette.primary,
                      },
                      marginLeft: "15%",
                    }}
                    defaultChecked={movingBoolean}
                    onChange={(e) => {
                      setMovingBoolean(e.target.checked);
                    }}
                  />
                }
                label={intl.formatMessage({ id: "moving.average" })}
              />
              {movingBoolean && (
                <div style={{ display: "flex", alignItems: "center", marginBottom: "0.8rem" }}>
                  <TextField
                    id={`channel_length_${title}`}
                    style={{ marginRight: "0.5rem", width: "7rem" }}
                    inputProps={{ min: selectedEquipment.channels[channel - 1].samplingInterval, max: 100 }}
                    defaultValue={movingAverage}
                    //error={errors[`channel_length_${indexChannel}`] ? true : false}
                    variant="outlined"
                    label={intl.formatMessage({ id: "window.size" }) + " (m)"}
                    type="number"
                    required
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onBlur={(e) => setMovingAverage(e.target.value)}
                  ></TextField>
                  <Button
                    id={`channel_length_${title}_button`}
                    variant="contained"
                    style={{
                      height: "3.6rem",
                      backgroundColor: loadingAverage ? palette.light : palette.primary,
                      color: "white",
                    }}
                    size="small"
                    disabled={loadingAverage}
                    onClick={async () => {
                      setLoadingAverage(true);
                      const measurementValues = [];
                      for (let datalistIndex = 0; datalistIndex < spatialDataList.length; datalistIndex++) {
                        const actualChannel = dateTimeList[datalistIndex][1];
                        const response = await getMovingAverageData({
                          asset: assetName,
                          equipment_ID: equipment,
                          channel: actualChannel,
                          substructure: substructure.ref,
                          date: spatialDataList[datalistIndex].datetime,
                          movingAverage: movingAverage,
                          module: assetModule,
                        });
                        measurementValues.push(response.data.data[measureName]);
                      }
                      const series = [
                        ...spatialDataList?.map((d, dIndex) => ({
                          name: d.datetime,
                          data: d.values.map((value, valueIndex) => [spatialDataList?.[0]?.pk[valueIndex], value]),
                          color: colors[dIndex],
                          type: "line",
                          lineStyle: {
                            width: 4.5,
                          },
                        })),
                        ...measurementValues?.map((d, dIndex) => ({
                          name: intl.formatMessage({ id: "moving.average" }) + " " + spatialDataList[dIndex].datetime,
                          data: d.map((value, valueIndex) => [spatialDataList?.[0]?.pk[valueIndex], value]),
                          type: "line",
                          symbolSize: 1,
                          color: colors[measurementValues.length + dIndex],
                        })),
                      ];
                      setChartMovingAverageData({
                        xAxis: {
                          data: spatialDataList?.[0]?.pk,
                        },
                        series: series,
                        title: `${intl.formatMessage({ id: title })} (${intl.formatMessage({ id: "moving.average" })})`,
                      });
                    }}
                  >
                    {intl.formatMessage({ id: "load.data" })}
                  </Button>
                </div>
              )}{" "}
              <Divider orientation="vertical" style={{ borderColor: palette.dividerLight, marginLeft: "1rem" }} />
              <FormControlLabel
                control={
                  <Checkbox
                    id={"checkbox" + title}
                    sx={{
                      color: palette.primary,
                      "&.Mui-checked": {
                        color: palette.primary,
                      },
                      marginLeft: "15%",
                    }}
                    checked={selectTemporal}
                    onChange={(e) => {
                      setSelectTemporal(e.target.checked);
                    }}
                  />
                }
                label={intl.formatMessage({ id: "temporal.selector" })}
              />
            </>
          ) : (
            userData.role !== "viewer" && (
              <>
                <Button
                  variant="contained"
                  component="span"
                  onClick={() => {
                    setDobModal(true);
                  }}
                >
                  {intl.formatMessage({ id: "add reading" })}
                </Button>
                <Button
                  variant="contained"
                  component="span"
                  sx={{
                    marginLeft: "1%",
                  }}
                  onClick={() => {
                    setDobHistorical(!dobHistorical);
                  }}
                >
                  {intl.formatMessage({ id: "show historical" })}
                </Button>
                {dobModal && (
                  <ThemeProvider theme={theme}>
                    <Dialog open={dobModal} onClose={() => setDobModal(false)}>
                      <DialogTitle style={{ fontSize: "x-large", color: palette.primary, fontWeight: "600" }}>
                        {intl.formatMessage({ id: "add reading" })}
                      </DialogTitle>
                      <DialogContent style={{ paddingBottom: "0" }}>
                        <form autoComplete="off">
                          <div>
                            <Divider style={{ marginBottom: "1rem", color: palette.primary }} />
                            <div style={{ width: "100%", height: "100%" }}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "baseline",
                                  gap: "0.5rem",
                                  padding: "1rem",
                                }}
                              >
                                <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
                                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                      id="date_picker"
                                      label={intl.formatMessage({ id: "date" })}
                                      format="dd-MM-yyyy"
                                      value={selectedDate}
                                      shouldDisableDate={(date) => {
                                        const formatted = format(date, "yyyy-MM-dd");
                                        const today = startOfDay(new Date());

                                        const isInvalidDob = dobDates.includes(formatted);
                                        const isFuture = startOfDay(date) > today;

                                        const shouldDisable = isInvalidDob || isFuture;

                                        return shouldDisable;
                                      }}
                                      onChange={(e) => {
                                        setSelectedDate(e);
                                      }}
                                    />
                                  </LocalizationProvider>
                                  <input
                                    type="file"
                                    accept=".csv, .json"
                                    style={{ display: "none" }}
                                    id="file-input"
                                    onChange={(event) => {
                                      setDobFile(event.target.files[0]);
                                    }}
                                  />
                                  <label htmlFor="file-input">
                                    <Button variant="contained" component="span">
                                      {intl.formatMessage({ id: "upload.file" })}
                                    </Button>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <Divider style={{ marginTop: "1rem" }} />
                          </div>
                        </form>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          variant="contained"
                          style={{ backgroundColor: palette.secondary, color: "white" }}
                          onClick={() => {
                            setDobModal(false);
                          }}
                        >
                          {intl.formatMessage({ id: "cancel" })}
                        </Button>
                        <LoadingButton
                          variant="contained"
                          loading={loading ?? false}
                          style={{
                            backgroundColor: loading ? palette.light : palette.primary,
                            color: "white",
                          }}
                          onClick={async () => {
                            //handleModalAccept(date, time, modalChannel, modalSub);
                            const date = new Date(selectedDate);
                            const year = date.getFullYear();
                            const month = ("0" + (date.getMonth() + 1)).slice(-2);
                            const day = ("0" + date.getDate()).slice(-2);

                            const formattedDate = year + "-" + month + "-" + day;
                            //loadDoBfile({ channel, data: allData, event: dobFile, measurandsFiltered, setData });
                            const data = {
                              asset: assetName,
                              equipmentID: equipment,
                              channel: channel,
                              substructure: substructure.ref,
                              module: assetModule,
                              package: measureName,
                              dateTime: formattedDate,
                            };
                            console.log(data);
                            const response = await postDoBData({ data, file: dobFile, intl });
                            if (response?.status === 200) {
                              let newDobDates = clone(dobDates);
                              newDobDates.push(formattedDate);
                              setDobDates(newDobDates);
                              loadDoBfile({
                                channel,
                                data: allData,
                                event: dobFile,
                                measurandsFiltered,
                                setData,
                                date: formattedDate,
                              });
                            }
                            setDobModal(false);
                          }}
                        >
                          {intl.formatMessage({ id: "accept" })}
                        </LoadingButton>
                      </DialogActions>
                    </Dialog>
                  </ThemeProvider>
                )}
              </>
            )
          )}
        </div>
        <div style={{ display: "flex", width: "100%" }}>
          {measureName.includes("dob") || measureName === "DoB" ? (
            <DoBLineChart
              withToolbox
              id={`${measureName}-spatial`}
              prefix={`${measureName}-spatial`}
              data={!isNil(chartMovingAverageData) ? chartMovingAverageData : chartSpatialData}
              measureName={measureName}
              isAlert={isAlert}
              assetModule={assetModule}
              configData={configData}
              resetZoomHandler={() => {
                setStartZoom(0);
                setEndZoom(100);
                setTemporalDataList([]);
              }}
              pointsSelectHandler={(start, end, auxAfter) => {
                const periodValue = isNil(periodRef.current) ? period : periodRef.current.value;
                const maximumValue = isNil(maximumRef.current) ? maximum : maximumRef.current.value;
                spatialSelectHandler({
                  data: !isNil(chartMovingAverageData) ? chartMovingAverageData : chartSpatialData,
                  start,
                  end,
                  setStartIndex,
                  setEndIndex,
                  measureName,
                  setTemporalDataList,
                  setEnvironmentalDataList,
                  minsWaterfall,
                  setMinsWaterfall,
                  maxsWaterfall,
                  setMaxsWaterfall,
                  currentAsset,
                  spatialDataList,
                  setLoading,
                  datetime,
                  selectedEquipment,
                  equipment,
                  channel,
                  substructure,
                  period: periodValue,
                  maximum: maximumValue,
                  alertMeasure,
                  startDate,
                  afterAlert: auxAfter,
                  setAfterAlert,
                  equipmentTypes,
                  manualPk: null,
                  assetSensors,
                  intensityData,
                });
              }}
              startIndex={startIndex}
              endIndex={endIndex}
              startZoom={startZoom ?? 0}
              endZoom={endZoom ?? 100}
              alertMeasure={alertMeasure}
              afterAlert={afterAlert}
              setAfterAlert={setAfterAlert}
              alertLines={alertLines}
              setAlertLines={setAlertLines}
              intl={intl}
              setLoadingAverage={setLoadingAverage}
              setLoadingAverageTemporal={setLoadingAverageTemporal}
              info={{ asset: assetName, equipment: selectedEquipment, channel: channel, dateTime: datetime }}
              manualPk={manualPk}
              assetInfo={assetInfo}
              selectTemporal={selectTemporal}
            />
          ) : (
            <LineChart
              withToolbox
              id={`${measureName}-spatial`}
              prefix={`${measureName}-spatial`}
              data={!isNil(chartMovingAverageData) ? chartMovingAverageData : chartSpatialData}
              measureName={measureName}
              isAlert={isAlert}
              assetModule={assetModule}
              configData={configData}
              resetZoomHandler={() => {
                setStartZoom(0);
                setEndZoom(100);
                setTemporalDataList([]);
              }}
              pointsSelectHandler={(start, end, auxAfter) => {
                const periodValue = isNil(periodRef.current) ? period : periodRef.current.value;
                const maximumValue = isNil(maximumRef.current) ? maximum : maximumRef.current.value;
                spatialSelectHandler({
                  data: !isNil(chartMovingAverageData) ? chartMovingAverageData : chartSpatialData,
                  start,
                  end,
                  setStartIndex,
                  setEndIndex,
                  measureName,
                  setTemporalDataList,
                  setEnvironmentalDataList,
                  minsWaterfall,
                  setMinsWaterfall,
                  maxsWaterfall,
                  setMaxsWaterfall,
                  currentAsset,
                  spatialDataList,
                  setLoading,
                  datetime,
                  selectedEquipment,
                  equipment,
                  channel,
                  substructure,
                  period: periodValue,
                  maximum: maximumValue,
                  alertMeasure,
                  startDate,
                  afterAlert: auxAfter,
                  setAfterAlert,
                  equipmentTypes,
                  manualPk: null,
                  assetSensors,
                  intensityData,
                });
              }}
              startIndex={startIndex}
              endIndex={endIndex}
              startZoom={startZoom ?? 0}
              endZoom={endZoom ?? 100}
              alertMeasure={alertMeasure}
              afterAlert={afterAlert}
              setAfterAlert={setAfterAlert}
              alertLines={alertLines}
              setAlertLines={setAlertLines}
              intl={intl}
              setLoadingAverage={setLoadingAverage}
              setLoadingAverageTemporal={setLoadingAverageTemporal}
              info={{ asset: assetName, equipment: selectedEquipment, channel: channel, dateTime: datetime }}
              manualPk={manualPk}
              intensityData={intensityData}
              assetInfo={assetInfo}
              selectTemporal={selectTemporal}
            />
          )}

          {measureName.includes("dob") || measureName === "DoB" ? (
            <MapDob
              assetData={currentAsset}
              intl={intl}
              spatialDataList={spatialDataList}
              dateTimeList={dateTimeList}
              measureName={measureName}
              scales={scales}
              percentiles={percentiles}
              equipmentData={selectedEquipment}
              differences={differences}
              chartSpatialData={chartSpatialData}
            />
          ) : (
            <MapAnalysis
              assetData={currentAsset}
              intl={intl}
              measureName={measureName}
              spatialDataList={spatialDataList}
              temporalDataList={temporalDataList}
              points={assetsPoints?.data}
              startIndex={startIndex}
              endIndex={endIndex}
              scales={scales}
              percentiles={percentiles}
              differences={differences}
              equipmentData={selectedEquipment}
              dateTimeList={dateTimeList}
              assetModule={assetModule}
              configData={configData}
            />
          )}
        </div>
      </div>
      {(!isEmpty(temporalDataList) || (!isEmpty(environmentalDataList) && isEmpty(temporalDataList))) &&
        !isNil(chartTemporalData) &&
        !loading && (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: 0, margin: 0 }}>
            <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
              <TextField
                select
                style={{ width: 150 }}
                id={`${measureName}_period_chart`}
                variant="outlined"
                label={intl.formatMessage({ id: "period" })}
                margin="dense"
                value={period}
                onChange={(e) => {
                  setPeriod(e.target.value);
                }}
                inputRef={periodRef}
              >
                <MenuItem key={7} value={7}>
                  7 {intl.formatMessage({ id: "days" })}
                </MenuItem>
                <MenuItem key={30} value={30}>
                  30 {intl.formatMessage({ id: "days" })}
                </MenuItem>
                <MenuItem key={60} value={60}>
                  60 {intl.formatMessage({ id: "days" })}
                </MenuItem>
                <MenuItem key={90} value={90}>
                  90 {intl.formatMessage({ id: "days" })}
                </MenuItem>
                <MenuItem key={365} value={365}>
                  1 {intl.formatMessage({ id: "year" })}
                </MenuItem>
                <MenuItem key={Infinity} value={Infinity}>
                  {intl.formatMessage({ id: "all.time" })}
                </MenuItem>
              </TextField>
              <TextField
                select
                style={{ marginLeft: "1.10%", marginRight: "1.10%", width: 150 }}
                id={`${measureName}_max_chart`}
                variant="outlined"
                label={intl.formatMessage({ id: "max.registers" })}
                margin="dense"
                value={maximum}
                onChange={(e) => {
                  setMaximum(e.target.value);
                }}
                inputRef={maximumRef}
              >
                <MenuItem key={1000} value={1000}>
                  1000
                </MenuItem>
                <MenuItem key={5000} value={5000}>
                  5000
                </MenuItem>
                <MenuItem key={10000} value={10000}>
                  10000
                </MenuItem>
                <MenuItem key={25000} value={25000}>
                  25000
                </MenuItem>
                <MenuItem key={Infinity} value={Infinity}>
                  {intl.formatMessage({ id: "no.limits" })}
                </MenuItem>
              </TextField>
              {startIndex === endIndex && (
                <FormControlLabel
                  control={
                    <Checkbox
                      id={"checkbox" + title + "temporal"}
                      sx={{
                        color: palette.primary,
                        "&.Mui-checked": {
                          color: palette.primary,
                        },
                        marginLeft: "35%",
                      }}
                      defaultChecked={movingBooleanTemporal}
                      onChange={(e) => {
                        setMovingBooleanTemporal(e.target.checked);
                      }}
                    />
                  }
                  label={intl.formatMessage({ id: "moving.average" })}
                />
              )}
              {movingBooleanTemporal && (
                <div style={{ display: "flex", alignItems: "center", marginBottom: "0.8rem" }}>
                  <TextField
                    id={`moving_average_${title}_temporal`}
                    style={{ margin: "1.10%" }}
                    inputProps={{
                      min:
                        selectedEquipment.measurementInfo.interval /
                        (averageMeasurement === "days" ? 86400 : averageMeasurement === "hours" ? 3600 : 60),
                      max:
                        7776000 / (averageMeasurement === "days" ? 86400 : averageMeasurement === "hours" ? 3600 : 60),
                    }}
                    value={temporalValue}
                    //error={errors[`channel_length_${indexChannel}`] ? true : false}
                    variant="outlined"
                    label={intl.formatMessage({ id: "window.size" })}
                    type="number"
                    required
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => {
                      setTemporalValue(e.target.value);
                    }}
                    onBlur={(e) => {
                      const conversor =
                        averageMeasurement === "days" ? 86400 : averageMeasurement === "hours" ? 3600 : 60;

                      const value = Number(e.target.value);

                      if (!isNaN(value)) {
                        setMovingAverageTemporal(value * conversor);
                      }
                    }}
                  ></TextField>
                  <TextField
                    select
                    style={{ width: 150, margin: "1.10%" }}
                    id={`${title}_average_measurement`}
                    variant="outlined"
                    margin="dense"
                    value={averageMeasurement}
                    onChange={(e) => {
                      setTemporalValue(
                        movingAverageTemporal /
                          (e.target.value === "days" ? 86400 : e.target.value === "hours" ? 3600 : 60),
                      );
                      setAverageMeasurement(e.target.value);
                    }}
                    //inputRef={maximumRef}
                  >
                    <MenuItem key={"days"} value={"days"}>
                      {intl.formatMessage({ id: "days" })}
                    </MenuItem>
                    <MenuItem key={"hours"} value={"hours"}>
                      {intl.formatMessage({ id: "hours" })}
                    </MenuItem>
                    <MenuItem key={"minutes"} value={"minutes"}>
                      {intl.formatMessage({ id: "minutes" })}
                    </MenuItem>
                  </TextField>
                  <Button
                    variant="contained"
                    style={{
                      margin: "1.10%",
                      height: "3.6rem",
                      backgroundColor: loadingAverageTemporal ? palette.light : palette.primary,
                      color: "white",
                    }}
                    size="small"
                    disabled={loadingAverageTemporal}
                    onClick={async () => {
                      loadAverageTemporalData({
                        assetName,
                        equipment,
                        channel,
                        datetime,
                        movingAverageTemporal,
                        manualPk,
                        maximum,
                        period,
                        assetModule,
                        substructure,
                        measureName,
                        temporalDataList,
                        colors,
                        title,
                        setLoadingAverageTemporal,
                        setChartMovingAverageTemporal,
                        intl,
                      });
                    }}
                  >
                    {intl.formatMessage({ id: "load.data" })}
                  </Button>
                </div>
              )}
            </div>
            <div style={{ width: "100%" }}>
              {startIndex === endIndex ? (
                <LineChart
                  withToolbox
                  prefix={`${measureName}-temporal`}
                  data={!isNil(chartMovingAverageTemporal) ? chartMovingAverageTemporal : chartTemporalData}
                  environmentalData={chartEnvironmentalData}
                  isAlert={isAlert}
                  alertMeasure={alertMeasure}
                  measureName={measureName}
                  afterAlert={afterAlert}
                  setAfterAlert={setAfterAlert}
                  alertLines={alertLines}
                  assetModule={assetModule}
                  configData={configData}
                  setAlertLines={setAlertLines}
                  setLoadingAverage={setLoadingAverage}
                  setLoadingAverageTemporal={setLoadingAverageTemporal}
                  info={{ asset: assetName, equipment: selectedEquipment, channel: channel, dateTime: datetime }}
                  manualPk={manualPk}
                  assetInfo={assetInfo}
                  intensityData={intensityData}
                  selectTemporal={selectTemporal}
                  intl={intl}
                />
              ) : (
                <WaterfallChart
                  prefix={`${measureName}-waterfall`}
                  data={chartTemporalWaterfallData}
                  configData={configData}
                  boundaries={
                    measureName === "strain"
                      ? [-maxsWaterfall?.[measureName], maxsWaterfall?.[measureName]]
                      : [minsWaterfall?.[measureName], maxsWaterfall?.[measureName]]
                  }
                  colorRange={measureName === "strain" ? waterfallColors.seismic : waterfallColors.jet}
                  intl={intl}
                />
              )}
            </div>
          </div>
        )}
      {loading && (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
            <TextField
              select
              style={{ width: 150 }}
              id="period_chart"
              variant="outlined"
              label={intl.formatMessage({ id: "period" })}
              margin="dense"
              value={period}
              onChange={(e) => {
                setPeriod(e.target.value);
              }}
            >
              <MenuItem key={7} value={7}>
                7 {intl.formatMessage({ id: "days" })}
              </MenuItem>
              <MenuItem key={30} value={30}>
                30 {intl.formatMessage({ id: "days" })}
              </MenuItem>
              <MenuItem key={60} value={60}>
                60 {intl.formatMessage({ id: "days" })}
              </MenuItem>
              <MenuItem key={90} value={90}>
                90 {intl.formatMessage({ id: "days" })}
              </MenuItem>
              <MenuItem key={365} value={365}>
                1 {intl.formatMessage({ id: "year" })}
              </MenuItem>
              <MenuItem key={"period" + Infinity} value={null}>
                {intl.formatMessage({ id: "all.time" })}
              </MenuItem>
            </TextField>
            <TextField
              select
              style={{ width: 150 }}
              id="max_chart"
              variant="outlined"
              label={intl.formatMessage({ id: "max.registers" })}
              margin="dense"
              value={maximum}
              onChange={(e) => {
                setMaximum(e.target.value);
              }}
            >
              <MenuItem key={1000} value={1000}>
                1000
              </MenuItem>
              <MenuItem key={5000} value={5000}>
                5000
              </MenuItem>
              <MenuItem key={10000} value={10000}>
                10000
              </MenuItem>
              <MenuItem key={25000} value={25000}>
                25000
              </MenuItem>
              <MenuItem key={"register" + Infinity} value={Infinity}>
                {intl.formatMessage({ id: "no.limits" })}
              </MenuItem>
            </TextField>
          </div>
          <div style={{ width: "100%" }}>
            {startIndex === endIndex ? (
              <LineChart
                prefix={`${measureName}-temporal-empty`}
                data={[]}
                environmentalData={[]}
                setLoadingAverageTemporal={setLoadingAverageTemporal}
                setLoadingAverage={setLoadingAverage}
                configData={configData}
                assetModule={assetModule}
                measureName={measureName}
                manualPk={manualPk}
                assetInfo={assetInfo}
                intl={intl}
              />
            ) : (
              <WaterfallChart
                prefix={`${measureName}-waterfall-empty`}
                data={[]}
                boundaries={[0, 1]}
                configData={configData}
                colorRange={
                  measureName === "strain"
                    ? ["#004700", "#006600", "#00b300", "#ffffbf", "#fdae61", "#f46d43", "#a50026"]
                    : [
                        "#313695",
                        "#4575b4",
                        "#74add1",
                        "#abd9e9",
                        "#e0f3f8",
                        "#ffffbf",
                        "#fee090",
                        "#fdae61",
                        "#f46d43",
                        "#d73027",
                        "#a50026",
                      ]
                }
              />
            )}
          </div>
        </div>
      )}
      {dobHistorical &&
        (() => {
          const alertData = allAlerts.measurements.filter(
            (alert) =>
              alert.asset === assetName &&
              alert.equipmentID === equipment &&
              alert.substructure === substructure.name &&
              alert.type === "sdob",
          );
          const actualPoints =
            assetsPoints.data[`${assetName}_${substructure.polyline}_${selectedEquipment.equipmentType}`].points;
          const seaLocation = actualPoints.findIndex((point) => point.surface_type === "sea");
          const dates = alertData.flatMap((alert) => [new Date(alert.dateStart), new Date(alert.dateEnd)]);
          const minDate = new Date(Math.min(...dates.map((d) => d.getTime())));
          const maxDate = new Date(Math.max(...dates.map((d) => d.getTime())));
          const deducter = seaLocation >= 0 ? actualPoints[seaLocation].pk : 0;

          const maxX = Math.max(...alertData.map((a) => a.endPoint - deducter));
          const shapes = [];
          const colors = ["rgba(255, 174, 0, 0.48)", "rgba(255, 0, 13, 0.4)"];
          for (let indexAlert = 0; indexAlert < alertData.length; indexAlert++) {
            shapes.push({
              type: "rect",
              xref: "x",
              yref: "y",
              x0: alertData[indexAlert].startPoint - deducter,
              x1: alertData[indexAlert].endPoint - deducter,
              y0: new Date(alertData[indexAlert].dateStart).toISOString(),
              y1: new Date(alertData[indexAlert].dateEnd).toISOString(),
              fillcolor: colors[alertData[indexAlert].value - 1],
              line: { width: 0 },
              layer: "below",
            });
          }
          const layout = {
            title: "DOB HISTORICO",
            xaxis: {
              title: {
                text: "PK (m)",
                font: { color: "#333" },
              },
              type: "value",
              range: [0, maxX],
              showgrid: true,
              gridcolor: "rgba(0,0,0,0.05)",
              linecolor: "rgba(0,0,0,0.4)",
              linewidth: 1,
              showline: true,
              tickfont: { color: "#333" },
            },
            yaxis: {
              title: {
                text: intl.formatMessage({ id: "date" }).toUpperCase(),
                font: { color: "#333" },
              },
              type: "date",
              range: [minDate.toISOString(), maxDate.toISOString()],
              showgrid: true,
              gridcolor: "rgba(0, 0, 0, 0.05)",
              linecolor: "rgba(0,0,0,0.4)",
              linewidth: 1,
              showline: true,
              tickfont: { color: "#333" },
            },
            paper_bgcolor: "transparent",
            plot_bgcolor: "transparent",
            margin: { l: 80, r: 20, t: 40, b: 60 },
            shapes: shapes,
          };
          return (
            <Plot
              data={[
                {
                  x: [0, maxX],
                  y: [minDate.toISOString(), maxDate.toISOString()],
                  mode: "markers",
                  marker: { opacity: 0 },
                  showlegend: false,
                  hoverinfo: "skip",
                  type: "scatter",
                },
              ]}
              layout={layout}
              style={{ width: "100%", height: "500px" }}
            />
          );
        })()}
    </div>
  ) : (
    measureName === "DoB" && userData.role !== "viewer" && (
      <div
        style={{
          width: "99%",
          margin: "1rem",
          padding: "0.5rem",
          display: "grid",
          gap: "1rem",
          border: `1px solid ${palette.primary}`,
          pointerEvents: loading ? "none" : "auto",
          position: "relative",
        }}
      >
        <h3 style={{ color: palette.primary }}>{intl.formatMessage({ id: title }).toUpperCase()}</h3>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <h4>{intl.formatMessage({ id: "no.dob" })}</h4>
          <Button
            variant="contained"
            component="span"
            onClick={() => {
              setDobModal(true);
            }}
          >
            {intl.formatMessage({ id: "add reading" })}
          </Button>
        </div>

        {dobModal && (
          <ThemeProvider theme={theme}>
            <Dialog open={dobModal} onClose={() => setDobModal(false)}>
              <DialogTitle style={{ fontSize: "x-large", color: palette.primary, fontWeight: "600" }}>
                {intl.formatMessage({ id: "add reading" })}
              </DialogTitle>
              <DialogContent style={{ paddingBottom: "0" }}>
                <form autoComplete="off">
                  <div>
                    <Divider style={{ marginBottom: "1rem", color: palette.primary }} />
                    <div style={{ width: "100%", height: "100%" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "baseline",
                          gap: "0.5rem",
                          padding: "1rem",
                        }}
                      >
                        <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              id="date_picker"
                              label={intl.formatMessage({ id: "date" })}
                              format="dd-MM-yyyy"
                              value={selectedDate}
                              onChange={(e) => {
                                setSelectedDate(e);
                              }}
                            />
                          </LocalizationProvider>
                          <input
                            type="file"
                            accept=".csv, .json"
                            style={{ display: "none" }}
                            id="file-input"
                            onChange={(event) => {
                              setDobFile(event.target.files[0]);
                            }}
                          />
                          <label htmlFor="file-input">
                            <Button variant="contained" component="span">
                              {intl.formatMessage({ id: "upload.file" })}
                            </Button>
                          </label>
                        </div>
                      </div>
                    </div>
                    <Divider style={{ marginTop: "1rem" }} />
                  </div>
                </form>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  style={{ backgroundColor: palette.secondary, color: "white" }}
                  onClick={() => {
                    setDobModal(false);
                  }}
                >
                  {intl.formatMessage({ id: "cancel" })}
                </Button>
                <LoadingButton
                  variant="contained"
                  loading={loading ?? false}
                  style={{
                    backgroundColor: loading ? palette.light : palette.primary,
                    color: "white",
                  }}
                  onClick={async () => {
                    //handleModalAccept(date, time, modalChannel, modalSub);
                    const date = new Date(selectedDate);
                    const year = date.getFullYear();
                    const month = ("0" + (date.getMonth() + 1)).slice(-2);
                    const day = ("0" + date.getDate()).slice(-2);

                    const formattedDate = year + "-" + month + "-" + day;

                    const data = {
                      asset: assetName,
                      equipmentID: equipment,
                      channel: channel,
                      substructure: substructure.ref,
                      module: assetModule,
                      package: measureName,
                      dateTime: formattedDate,
                    };
                    console.log(data);
                    const response = await postDoBData({ data, file: dobFile, intl });
                    if (response?.status === 200) {
                      loadDoBfile({ channel, data: allData, event: dobFile, measurandsFiltered, setData });
                    }
                    setDobModal(false);
                  }}
                >
                  {intl.formatMessage({ id: "accept" })}
                </LoadingButton>
              </DialogActions>
            </Dialog>
          </ThemeProvider>
        )}
      </div>
    )
  );
};

export default NormalDataVisualization;
